import {
  spanishMexicoMovies,
  spanishMexicoMoviesForEnUs,
} from '../data/spanishMexicoMovies/spanishMexico';
import { MoviesTagPageContent } from '../MoviesTagPageContent';
import { TagPageProps } from '../types/tagPageProps';

export const Content = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={spanishMexicoMovies} />
);

export const ContentEnUs = (props: TagPageProps) => (
  <MoviesTagPageContent {...props} movies={spanishMexicoMoviesForEnUs} />
);
